module.exports = "/images/hands@2x.png?5f248e84b7e6868e249648857c8b002f";